import { z } from "zod";

export const PaymentTemplateFormSchema = z.object({
  name: z.string().trim().min(1, "Payment name is required"),
  description: z.string(),
  amount: z
    .string()
    .refine(
      (value) =>
        value.trim() !== "" &&
        !Number.isNaN(parseFloat(value)) &&
        parseFloat(value) > 0,
      { message: "Enter an amount greater than 0" }
    ),
});

export type PaymentTemplateFormData = z.infer<typeof PaymentTemplateFormSchema>;

export const emptyPaymentTemplateForm: PaymentTemplateFormData = {
  name: "",
  description: "",
  amount: "",
};
